<h4 class="secondary-text" style="text-align: left; margin: 0 0 12px -10px">
    <button mat-icon-button
            color="primary"
            title="Back to sign in page"
            (click)="onBackToMFALogIn()"
    >
        <mat-icon aria-hidden="true">arrow_back</mat-icon>
    </button>
    back to MFA sign in page
</h4>

<div class="title" style="text-align: left">
    Enter Recovery code
</div>

<form name="loginForm" [formGroup]="loginForm" (ngSubmit)="onFormSubmit(loginForm.value)" novalidate>

    <h3>You can enter one of your recovery codes in case you lost access to your mobile device.</h3>

    <mat-form-field>
        <input matInput
               placeholder="Recovery Code"
               formControlName="recoveryCode"
               name="recoveryCode"
        >
        <mat-error *ngIf="loginFormErrors?.recoveryCode?.required">
            Code is required
        </mat-error>
    </mat-form-field>

    <button mat-raised-button color="accent"
            class="submit-button"
            aria-label="Sign in"
            [disabled]="(loading$ | async)"
    >
        Confirm
    </button>

    <div fxLayout="row"
         fxLayoutAlign="center center"
    >
        <a class="contact-link"
           [href]="supportUrl"
        >
            Contact Support
        </a>
    </div>
</form>
